import Main from "./features/main";

function App() {
  return <Main />;
}

export default App;
